import users from '@/apis/coreIAM/users'
import { usersTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        current: null,
        fetchAll: {
            pending: false,
            error: null
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [usersTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [usersTypes.FETCH_ALL_SUCCESS]: function (state, users) {
            state.fetchAll.error = null;
            state.all = users;
            state.fetchAll.pending = false;
        },
        [usersTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [usersTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [usersTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [usersTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [usersTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [usersTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [usersTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [usersTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [usersTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [usersTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [usersTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [usersTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [usersTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(usersTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                users
                    .fetchAll()
                    .then((users) => {
                        commit(usersTypes.FETCH_ALL_SUCCESS, users.data);
                        resolve(users.data);
                    })
                    .catch((error) => {
                        commit(usersTypes.FETCH_ALL_FAILURE, error);
                        reject(error);
                    })
            })
        },
        async fetchOne({ commit }, payload) {
            commit(usersTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                users
                    .fetchOne(payload.userUuid)
                    .then((user) => {
                        commit(usersTypes.FETCH_ONE_SUCCESS)
                        resolve(user.data)
                    })
                    .catch((error) => {
                        commit(usersTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(usersTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                users
                    .createUser(payload.name)
                    .then((user) => {
                        commit(usersTypes.CREATE_ONE_SUCCESS)
                        resolve(user.data)
                    })
                    .catch((error) => {
                        commit(usersTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(usersTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                users
                    .updateUser(payload.userUuid, payload.name)
                    .then((user) => {
                        commit(usersTypes.UPDATE_ONE_SUCCESS)
                        resolve(user.data)
                    })
                    .catch((error) => {
                        commit(usersTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(usersTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                users
                    .deleteUser(payload.userUuid)
                    .then(() => {
                        commit(usersTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(usersTypes.DELETE_ONE_FAILURE)
                        reject(error)
                    })
            })
        },
    },
}